var React = require('react');

function NavigateNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3,12a9,9 0 1,0 18,0a9,9 0 1,0 -18,0","fill":"#D8D8D8","fillRule":"evenodd","style":{"fill":"#D8D8D8"}}));
}

NavigateNext.defaultProps = {"width":"24","height":"24"};

module.exports = NavigateNext;

NavigateNext.default = NavigateNext;
